import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import * as Promo from 'src/replicant/promo';
import StateObserver from 'src/StateObserver';
import { actionBlock, singleAction } from '../launch/LaunchSequence';
import * as Social from 'src/replicant/social';
import { shouldShowGachaPromo, showGachaPromo } from '../gacha/gacha.sequence';
import { hasJoinedLeague } from 'src/replicant/match2/leagues/leagues.getters';
import features from 'src/replicant/ruleset/features';
import { launchPromoGroups } from './promo.launch';

/**
 * Put here promo launch sequence popups
 */
export const promoSequence = [
  /**
   * Show the invite challenge for control users.
   * Treatment users receive it through the centralized promo launch group.
   */
  actionBlock({
    enabled: ({ user }) =>
      !features(user).suppressFeatureIntros &&
      Social.getters.isInviteChallengeRunning(user, StateObserver.now()),
    actions: [
      async () => {
        await openPopupPromise('popupInviteChallenge', {});

        return false;
      },
    ],
  }),

  /**
   * Show the gacha promo for control users.
   */
  actionBlock({
    enabled: ({ user }) =>
      !features(user).suppressFeatureIntros && shouldShowGachaPromo(),
    actions: [
      async () => {
        await showGachaPromo();
        return false;
      },
    ],
  }),

  /**
   * Show master league promo for puzzle coins users
   */
  actionBlock({
    enabled: ({ user }, now) =>
      Promo.getters.isPromoReady(user, 'masterLeaguePuzzleCoins', now) &&
      hasJoinedLeague(user),
    actions: [
      async () => {
        await StateObserver.invoke.promoWasShown('masterLeaguePuzzleCoins');

        await openPopupPromise('popupLeaguesInfoPuzzleCoins', {});

        return false;
      },
    ],
  }),
];

/**
 * Treatment-only grouped promo launch block.
 *
 * This sequence is inserted after exempt launch flows so the coordinator can
 * apply the shared daily/recurring budget followed by the reserved FTUE slot.
 */
export const promoGroupLaunchSequence = [
  singleAction({
    enabled: ({ user }) => features(user).suppressFeatureIntros,
    action: () => launchPromoGroups(),
  }),
];
